module.exports = __webpack_public_path__ + "img/18.c9da3b98.jpg";